const checkResize = {
    isMobile: false,
    check: () => {
        checkResize.isMobile = window.innerWidth <= 1024;
    }
}

checkResize.check();

export default checkResize;
